import * as rutas from '../rutas/rutas'

const data_servicios = () => { 
  return (
    [
      { id: 'REGENCIA_QUIMICA',
        titulo: 'Regencia química',
        foto: 'Picture4-300x225x250.png',
        texto:
        'Este servicio se brinda a través de un contrato',
        rutaInfo: rutas.REGENCIA_QUIMICA_INFO, 
        rutaCotizacion: rutas.REGENCIA_QUIMICA_COTIZACION, 
        subservicios: []
      },
    
      { id: 'REGENCIA_AMBIENTAL',
        titulo: 'Regencia ambiental',
        foto: 'Picture4-300x225x250.png',
        texto:
        'Este servicio se brinda a través de un contrato',
        rutaInfo: '/regencia_quimica_info', 
        rutaCotizacion: '/regencia_quimica_cotizacion', 
        subservicios: []
      },  

      { id: 'REGENCIA_AMBIENTAL',
        titulo: 'Regencia ambiental',
        foto: 'Picture4-300x225x250.png',
        texto:
        'Este servicio se brinda a través de un contrato ',
        rutaInfo: '/regencia_quimica_info', 
        rutaCotizacion: '/regencia_quimica_cotizacion', 
        subservicios: []
      },  

      { id: 'REGENCIA_AMBIENTAL',
        titulo: 'Regencia ambiental',
        foto: 'Picture4-300x225x250.png',
        texto: 
        'Este servicio se brinda a través de un contrato',
        rutaInfo: '/regencia_quimica_info', 
        rutaCotizacion: '/regencia_quimica_cotizacion', 
        subservicios: []
      },  
      
      { id: 'REGENCIA_AMBIENTAL',
        titulo: 'Regencia ambiental',
        foto: 'Picture4-300x225x250.png',
        texto: 
        'Este servicio se brinda a través de un contrato',
        rutaInfo: '/regencia_quimica_info', 
        rutaCotizacion: '/regencia_quimica_cotizacion', 
        subservicios: []
      },       

      { id: 'REGENCIA_AMBIENTAL',
        titulo: 'Regencia ambiental',
        foto: 'Picture4-300x225x250.png',
        texto: 
        'Este servicio se brinda a través de un contrato',
        rutaInfo: '/regencia_quimica_info', 
        rutaCotizacion: '/regencia_quimica_cotizacion', 
        subservicios: []
      },  
    ]
  )
}

export default data_servicios




// WEBPACK FOOTER //
// ./src/Data/data_servicios.js